import $ from 'jquery';
import lightGallery from 'lightgallery';
import {browser} from "./basic/browserIdentify.js";
import {cookies} from "./commons/cookies.js";
import {layout} from "./commons/layout.js";
import {header} from "./commons/header.js";
import {scroll} from "./commons/scroll.js";

browser($);
cookies($);
header($);
layout($, lightGallery);
scroll($);
